export const getAuthTokenAsync = (): string | null => {
  try {
    const token = localStorage.getItem("token");
    return token;
  } catch (error) {
    console.error("Error fetching auth token: ", error);
    return null;
  }
};
